import { render, staticRenderFns } from "./aliPay.vue?vue&type=template&id=f4fb8734&scoped=true&"
import script from "./aliPay.vue?vue&type=script&lang=js&"
export * from "./aliPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fb8734",
  null
  
)

export default component.exports